var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useEffect } from "react";
import { Navigate, useLoaderData, useLocation, useParams } from "react-router-dom-v5-compat";
import { Routes } from "../Shared/components/Navigation/navigationUtils";
import { LocationPageWrapper } from "../Shared/components/PageWrapper/LocationPageWrapper";
import Loading from "../Shared/components/loading";
import { useLogging } from "../Shared/hooks/useLogging/useLogging";
import { axiosPrivate } from "../api/axios";
import { DeliverySection } from "./DeliverySection";
import { LocationContentArea } from "./LocationContentArea";
import { LocationSkeleton } from "./LocationSkeleton";
import { LocationTitle } from "./LocationTitle";
import { PickupSection } from "./PickupSection";
import { useLocations } from "./useLocations";
export const Location = () => {
    const location = useLocation();
    const { sku } = useParams();
    const { isValidFlowSku, skipLocationPage, defaultLocation, defaultPostalCode } = useLoaderData();
    const { loading: locationFetchLoading, error: locationFetchError, deliveryMethodMarkdown, pickupIcon, pickupIconColor, pickUpMarkdown, pickUpSubtext, deliveryIcon, deliveryIconColor, deliveryMarkdown, deliverySubtext, contentArea, locations, shouldDisplayLocationSection, shouldDisplayDeliverySection, programId } = useLocations(skipLocationPage);
    const { logReactPixelPageView, createKlaviyoEvent, gaPageView } = useLogging();
    useEffect(() => {
        if (!skipLocationPage) {
            logReactPixelPageView();
            gaPageView("Location", location.pathname);
            createKlaviyoEvent("PageView", {
                SelectedLocation: "Location",
            });
        }
    }, []);
    if (!isValidFlowSku) {
        return (_jsx(Navigate, { to: Routes.NOT_FOUND, replace: true, state: Object.assign(Object.assign({}, location.state), { prevRoute: location.pathname }) }));
    }
    if (skipLocationPage) {
        if (defaultPostalCode) {
            return (_jsx(Navigate, { to: `/${sku}/${Routes.ORDER_FLOW}`, replace: true, state: Object.assign(Object.assign({}, location.state), { postalCode: defaultPostalCode }) }));
        }
        if (defaultLocation) {
            return (_jsx(Navigate, { to: `/${sku}/${Routes.ORDER_FLOW}`, replace: true, state: Object.assign(Object.assign({}, location.state), { location: defaultLocation }) }));
        }
    }
    if (locationFetchError) {
        return _jsx(Loading, { error: true, text: locationFetchError });
    }
    if (locationFetchLoading) {
        return _jsx(LocationSkeleton, {});
    }
    return (_jsx(LocationPageWrapper, Object.assign({ id: "location-page-wrapper" }, { children: _jsxs(Stack, Object.assign({ spacing: 3 }, { children: [deliveryMethodMarkdown && _jsx(LocationTitle, Object.assign({}, { deliveryMethodMarkdown })), shouldDisplayDeliverySection && (_jsx(DeliverySection, { deliveryMarkdown: deliveryMarkdown, deliverySubtext: deliverySubtext, deliveryIcon: deliveryIcon, deliveryIconColor: deliveryIconColor, programId: programId })), shouldDisplayLocationSection && (_jsx(PickupSection, { pickUpMarkdown: pickUpMarkdown, pickUpSubtext: pickUpSubtext, locations: locations, pickupIcon: pickupIcon, pickupIconColor: pickupIconColor })), contentArea && _jsx(LocationContentArea, Object.assign({}, { contentArea }))] })) })));
};
export const LocationLoader = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const [skuValidation, locationData] = yield Promise.all([
            axiosPrivate.get(`/Location/ValidateFlowSku?sku=${params.sku}`),
            axiosPrivate.get(`/Location/GetLocationSkipInfo?sku=${params.sku}`)
        ]);
        return Object.assign(Object.assign({}, skuValidation.data), locationData.data);
    }
    catch (e) {
        console.error(e);
        throw e;
    }
});
